import { Component, Input } from "@angular/core";

@Component({
  selector: "app-feedbacks-carousel",
  templateUrl: "./feedbacks-carousel.component.html",
  styleUrls: ["./feedbacks-carousel.component.scss"],
})
export class FeedbacksCarouselComponent {
  @Input() feedbacks: string[] = [];

  @Input() title = "Feedbacks";
}
